import { BRAND_SECONDARY } from "../../../utils/Styles";
import * as React from "react";
import {
  IDropdownOption,
  Stack,
  DefaultButton,
  PrimaryButton,
  DayOfWeek,
  DatePicker,
  Dropdown,
  Checkbox,
  Breadcrumb,
  DropdownMenuItemType,
  ISelectableOption,
  Callout,
  DirectionalHint,
} from "office-ui-fabric-react";
import {
  IDataCenter,
  ISearchPac,
  IPACReading,
  IReadingStatus,
  IFloorVM,
} from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { useParams, useHistory } from "react-router-dom";
import {
  getADataCenter,
  getFloorsWhichHasUnits,
  getPowerComponents,
} from "../../../services/datacenter/DatacenterService";
import {
  getPacReadings,
  updatePacReadingStatus,
} from "../../../services/infrastructure/PacService";
import moment from "moment";
import NoDataTile from "../../common/NoDataTile";
import { Loading } from "../../../services/Loading";
import {
  childrenGap,
  EVEN_SHIFT,
  UPS_STATUS,
  READ_AT_TIME_FORMAT,
  childrenGap8,
} from "../../common/Constants";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight, mdiDotsVertical } from "@mdi/js";
import ManagePacDialog from "./ManagePacDialog";
import {
  getThreshold,
  isInThreshold,
  isValueLessThanThreshold,
} from "../../../services/ThresholdService";
import ManageAllRejectDialog from "../../common/ManageAllRejectDialog";
import ShowThresholdIcon from "../../common/ShowThresholdIcon";

export interface PacMainProps { }

const PacMain: React.FC<PacMainProps> = () => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isDatacenterFound: false,
    isPacLoaded: false,
    pacList: [],
    allPacDropdownList: [],
    allFloorsDropdownList: [],
    datacenter: undefined,
    searchObj: { datacenterId: "", date: new Date(), pacId: "" },
    pacReading: [],
    isIndeterminate: false,
    isAllChecked: false,
    selectedItems: [],
    pacObj: {},
    managePacDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    threshold: undefined,
    manageRejectDialog: {
      isOpen: false,
      ids: [],
      remarks: "",
    },
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    isDatacenterFound: boolean;
    isPacLoaded: boolean;
    pacList: any[];
    allPacDropdownList: IDropdownOption[];
    allFloorsDropdownList: IDropdownOption[];
    datacenter?: IDataCenter;
    searchObj: ISearchPac;
    pacReading: IPACReading[];
    isIndeterminate: boolean;
    isAllChecked: boolean;
    selectedItems: string[];
    pacObj: any;
    managePacDialog: {
      isOpen: boolean;
      index?: number;
      data?: IPACReading;
    };
    threshold: any;
    manageRejectDialog: {
      isOpen: boolean;
      ids: string[];
      remarks?: string;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      data?: IPACReading;
    };
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const params: any = useParams();
  const history = useHistory();

  const isMumbaiAndheri = ["5db6dd581622512263977721"].includes(
    params.dataCenterId
  );

  React.useEffect(() => {
    const asyncFunc = async () => {
      if (params.dataCenterId) {
        getDatacenter(params.dataCenterId);
      }
    };
    asyncFunc();
  }, []);

  const getDatacenter = async (datacenterId: string) => {
    setState({ ...state, isLoading: true });
    let result = await getADataCenter(datacenterId);
    if (result?.success) {
      setState({
        ...state,
        datacenter: result.data,
        isDatacenterFound: true,
        isLoading: false,
      });

      getFloorList(result.data);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getFloorList = async (datacenter: IDataCenter) => {
    setState({ ...state, isLoading: true });
    let result = await getFloorsWhichHasUnits({
      dataCenterId: params.dataCenterId,
      type: "pac",
    });
    if (result?.success) {
      let options: IDropdownOption[] = [];

      const floorByBuilding: { [Key: string]: IFloorVM[] } = result.data.reduce(
        (acc: any, d) => {
          if (acc[d.buildingId] == null) {
            acc[d.buildingId] = [];
          }

          acc[d.buildingId].push(d);
          return acc;
        },
        {}
      );
      let temp = Object.keys(floorByBuilding);
      temp.forEach((d, index) => {
        options.push({
          key: d,
          text: floorByBuilding[d][0].buildingName,
          itemType: DropdownMenuItemType.Header,
        });
        floorByBuilding[d].forEach((f) => {
          options.push({
            key: f.floorId,
            text: f.floorName,
            data: { buildingName: f.buildingName },
          });
        });
        if (temp.length != index + 1) {
          options.push({
            key: "divider_1",
            text: "-",
            itemType: DropdownMenuItemType.Divider,
          });
        }
      });

      // result.data.forEach((ele: any) => {
      //   options.push({
      //     key: ele.floorId,
      //     text: `${ele.buildingName} - ${ele.floorName}`,
      //   });
      // });
      getThresholdData(datacenter, options);
    } else {
      setState({ ...state, isLoading: false });
    }
  };

  const getThresholdData = async (
    datacenter: IDataCenter,
    allFloorsDropdownList: IDropdownOption[]
  ) => {
    setState({ ...state, isLoading: true });
    let result = await getThreshold("pac");
    if (result?.success) {
      getPowerComponentsList(
        datacenter,
        allFloorsDropdownList,
        result.data.threshold
      );
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getPowerComponentsList = async (
    datacenter: IDataCenter,
    allFloorsDropdownList: IDropdownOption[],
    threshold?: any
  ) => {
    setState({ ...state, isLoading: true });
    let result = await getPowerComponents({
      datacenterId: params.dataCenterId,
      types: ["pac", "pahu"],
    });
    if (result?.success) {
      let pacObj = result.data.reduce((acc, ele) => {
        if (acc[ele.floorId] == null) {
          acc[ele.floorId] = [];
        }
        acc[ele.floorId].push({ key: ele._id, text: ele.name });
        return acc;
      }, {});
      //   let options: IDropdownOption[] = [];
      //   result.data.forEach((ele) => {
      //     options.push({ key: ele._id, text: ele.name });
      //   });
      let obj = {
        ...state,
        pacList: result.data,
        isLoading: false,
        datacenter,
        isDatacenterFound: true,
        searchObj: {
          datacenterId: params.dataCenterId,
          date: new Date(),
          floorId:
            allFloorsDropdownList.length > 1
              ? (allFloorsDropdownList[1].key as string)
              : "",
          pacId:
            allFloorsDropdownList.length > 1 &&
              pacObj[allFloorsDropdownList[1].key as string]
              ? pacObj[allFloorsDropdownList[1].key as string][0]?.key
              : "",
        },
        pacObj,
        allPacDropdownList:
          allFloorsDropdownList.length > 1
            ? pacObj[allFloorsDropdownList[1].key as string]
            : [],
        allFloorsDropdownList,
        threshold,
      };
      setState(obj);
      getPacReadingsData(obj);
    } else {
      showToast(result?.message || "Error while getting pac list", "error");
      setState({ ...state, isLoading: false });
    }
  };
  const getPacReadingsData = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState != null) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let obj = { ...localState.searchObj };
    obj.date = moment(obj.date).format("YYYY-MM-DD");
    let result = await getPacReadings(obj);
    if (result?.success) {
      setState({
        ...localState,
        pacReading: result.data,
        isLoading: false,
        isPacLoaded: true,
      });
    } else {
      showToast(result?.message || "Error while getting pac readings", "error");
      setState({ ...localState, isLoading: false, isPacLoaded: false });
    }
  };

  const onSearch = async () => {
    if (!state.searchObj.floorId) {
      showToast("Please select a floor before searching", "error");
      return;
    }
    if (!state.searchObj.pacId) {
      showToast("Please select an pac before searching", "error");
      return;
    }
    getPacReadingsData();
    // console.log("state", state);
  };

  const handleAcceptOrReject = (id: string, isAccept: boolean) => {
    showConfirmDialog(
      "Are You Sure",
      `Do you want to ${isAccept ? "Accept" : "Reject"} the pac reading`,
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            element: undefined,
            data: undefined,
          },
        });
        let obj: IReadingStatus = {
          ids: [id],
          status: isAccept ? "approved" : "rejected",
        };
        let result = await updatePacReadingStatus(obj);
        if (result?.success) {
          let pacReading = [...state.pacReading];
          let index = pacReading.findIndex((ele) => ele._id === id);
          if (index !== -1) {
            pacReading[index].status = isAccept ? "approved" : "rejected";
          }
          let selectedItems = [...state.selectedItems];
          let indexToRemove = selectedItems.findIndex((ele) => ele === id);
          if (index !== -1) {
            selectedItems.splice(indexToRemove, 1);
          }
          showToast(
            `PAC Reading ${isAccept ? "approved" : "rejected"} successfully`,
            "success"
          );
          setState({
            ...state,
            pacReading,
            selectedItems,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          showToast(
            result?.message ||
            `An error occurred while ${isAccept ? "approving" : "rejecting"
            } a pac reading`,
            "error"
          );
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        }
      }
    );
  };

  const handleAcceptOrRejectSelected = (isAccept: boolean) => {
    if (isAccept) {
      showConfirmDialog(
        "Are You Sure",
        `Do you want to ${isAccept ? "Accept" : "Reject"} selected pac reading`,
        async () => {
          let selectedItems = [...state.selectedItems];
          let pacReading = [...state.pacReading];
          setState({
            ...state,
            isLoading: true,
          });
          let obj: IReadingStatus = {
            ids: selectedItems,
            status: isAccept ? "approved" : "rejected",
          };
          let result = await updatePacReadingStatus(obj);
          if (result?.success) {
            selectedItems.forEach((item) => {
              let index = pacReading.findIndex((ele) => ele._id === item);
              if (index !== -1) {
                pacReading[index].status = isAccept ? "approved" : "rejected";
              }
            });
            showToast(
              `PAC Reading ${isAccept ? "approved" : "rejected"} successfully`,
              "success"
            );
            setState({
              ...state,
              pacReading,
              selectedItems: [],
              isLoading: false,
            });
          } else {
            showToast(
              result?.message ||
              `An error occurred while ${isAccept ? "approving" : "rejecting"
              } a pac reading`,
              "error"
            );
            setState({
              ...state,
              isLoading: false,
            });
          }
        }
      );
    } else {
      let selectedItems = [...state.selectedItems];
      handleRejectAllOpenDialog(selectedItems);
    }
  };

  const onSelectAll = (isAllChecked: boolean) => {
    let selectedItems: string[] = [];
    if (isAllChecked) {
      state.pacReading.forEach((ele) => {
        if (ele.status === "submitted") {
          selectedItems.push(ele._id as string);
        }
      });
      setState({ ...state, isAllChecked: true, selectedItems });
    } else {
      setState({ ...state, isAllChecked: false, selectedItems });
    }
  };

  const onIndividualSelect = (id: string) => {
    let selectedItems = [...state.selectedItems];
    let index = selectedItems.findIndex((e) => e === id);
    if (index === -1) {
      selectedItems.push(id);
    } else {
      selectedItems.splice(index, 1);
    }
    let isAllChecked = true;
    state.pacReading.forEach((ele) => {
      if (
        ele.status === "submitted" &&
        selectedItems.includes(ele._id as string) === false
      ) {
        isAllChecked = false;
      }
    });
    setState({ ...state, selectedItems, isAllChecked });
  };

  const getMinValue = (property: string) => {
    let a = property.split(".");
    if (state.pacReading.length > 0) {
      let list = state.pacReading.map((ele: any) => {
        if (a[1]) {
          return ele[a[0]][a[1]];
        } else {
          return ele[a[0]];
        }
      });
      return Math.min(...list);
    } else {
      return "";
    }
  };
  const getMaxValue = (property: string) => {
    let a = property.split(".");
    if (state.pacReading.length > 0) {
      let list = state.pacReading.map((ele: any) => {
        if (a[1]) {
          return ele[a[0]][a[1]];
        } else {
          return ele[a[0]];
        }
      });
      return Math.max(...list);
    } else {
      return "";
    }
  };

  const handleDialogOpen = (isOpen: boolean, id?: string) => {
    let pacReading = undefined;
    let index = undefined;
    if (id !== undefined) {
      index = state.pacReading.findIndex((ele) => ele._id === id);
      pacReading = { ...state.pacReading[index] };
    }
    setState({
      ...state,
      managePacDialog: {
        isOpen: isOpen,
        index: index,
        data: pacReading,
      },
    });
    // console.log(pacReading);
  };

  const handleDialogClose = (data: IPACReading) => {
    let pacReading = [...state.pacReading];
    if (data) {
      if (state.managePacDialog.index !== undefined) {
        pacReading[state.managePacDialog.index] = data;
      }
    }
    setState({
      ...state,
      managePacDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      pacReading,
    });
  };

  const handleRejectAllOpenDialog = (ids: string[]) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: ids || [],
        remarks: "",
      },
    });
  };
  const handleRejectOpenDialog = (id: string, remarks?: string) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: [id],
        remarks: remarks || "",
      },
    });
  };

  const handleRejectCloseDialog = async (
    isSuccess: boolean,
    remarks?: string
  ) => {
    let pacReading = [...state.pacReading];
    let selectedItems: string[] = state.manageRejectDialog.ids;
    if (isSuccess) {
      setState({
        ...state,
        isLoading: true,
      });
      let obj: IReadingStatus = {
        ids: selectedItems,
        status: "rejected",
        remarks: remarks || "",
      };
      let result = await updatePacReadingStatus(obj);
      if (result?.success) {
        selectedItems.forEach((item) => {
          let index = pacReading.findIndex((ele) => ele._id === item);
          if (index !== -1) {
            pacReading[index].status = "rejected";
            pacReading[index].remarks = remarks || "";
          }
        });
        showToast(`PAC Reading rejected successfully`, "success");
        setState({
          ...state,
          pacReading,
          selectedItems: [],
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      } else {
        showToast(
          result?.message || `An error occurred while rejecting a pac reading`,
          "error"
        );
        setState({
          ...state,
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      }
    } else {
      setState({
        ...state,
        manageRejectDialog: {
          isOpen: false,
          ids: [],
          remarks: undefined,
        },
        pacReading,
      });
    }
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const onNextOrPrevFunc = (isPrev: boolean) => {
    let localState = { ...state };

    let currentSelectedFloor = localState.searchObj.floorId;
    let currentFloorList = localState.allFloorsDropdownList;
    let currentSelectedPac = localState.searchObj.pacId;
    let currentPacList = localState.allPacDropdownList;

    let currentPacIndex = currentPacList.findIndex(
      (d) => d.key === currentSelectedPac
    );

    if (isPrev) {
      if (currentPacIndex !== 0) {
        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            pacId: currentPacList[currentPacIndex - 1]?.key as string,
          },
        };
      } else {
        let currentFloorIndex = currentFloorList.findIndex(
          (d) => d.key === currentSelectedFloor
        );
        if (currentFloorIndex === 1) return;
        let currentFloor = currentFloorList[currentFloorIndex - 1];
        if (currentFloor.itemType) {
          // this is due to divider and header
          currentFloor = currentFloorList[currentFloorIndex - 3];
        }
        currentSelectedFloor = currentFloor.key as string;

        currentPacList = localState.pacObj[currentSelectedFloor];

        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            floorId: currentSelectedFloor,
            pacId: currentPacList[currentPacList.length - 1]?.key as string,
          },
          allPacDropdownList: currentPacList,
        };
      }
    } else {
      if (currentPacIndex !== currentPacList.length - 1) {
        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            pacId: currentPacList[currentPacIndex + 1]?.key as string,
          },
        };
      } else {
        let currentFloorIndex = currentFloorList.findIndex(
          (d) => d.key === currentSelectedFloor
        );
        if (currentFloorIndex === currentFloorList.length - 1) return;
        let currentFloor = currentFloorList[currentFloorIndex + 1];
        if (currentFloor.itemType) {
          // this is due to divider and header
          currentFloor = currentFloorList[currentFloorIndex + 3];
        }
        currentSelectedFloor = currentFloor.key as string;

        currentPacList = localState.pacObj[currentSelectedFloor];

        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            floorId: currentSelectedFloor,
            pacId: currentPacList[0]?.key as string,
          },
          allPacDropdownList: currentPacList,
        };
      }
    }
    // console.log("[onNextOrPrevFunc localState]", localState);
    getPacReadingsData(localState);
  };

  const onRenderOption = (option?: ISelectableOption): JSX.Element => {
    if (!option) return <div />;
    return (
      <div className="d-flex">
        {/* {!option.itemType && <Icon path={mdiFloorPlan} size={0.8} />} */}
        <span style={{ marginLeft: option.itemType ? "0px" : "12px" }}>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    if (!options) return <div />;
    const option = options[0];

    return (
      <div>
        <span>{option.data.buildingName + "-" + option.text}</span>
      </div>
    );
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    data?: IPACReading
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isDatacenterFound ? (
        <React.Fragment>
          <Stack>
            <Stack.Item>
              <Stack.Item>
                {/* <Text variant="xLarge">
                  PAC/PAHU Readings -{" "}
                  {state.datacenter && state.datacenter.name}{" "}
                  {state.datacenter && state.datacenter.location && " - "}
                  {state.datacenter && state.datacenter.location}
                </Text> */}
                <Breadcrumb
                  items={[
                    {
                      text: state.datacenter
                        ? state.datacenter.name
                        : "Datacenter",
                      key: "datacenter",
                    },
                    {
                      text: "Infrastructures",
                      key: "infrastructure",
                      onClick: () => {
                        history.goBack();
                      },
                    },
                    {
                      text: "PAC/PAHU Readings",
                      key: "pac-readings",
                      isCurrentItem: true,
                    },
                  ]}
                />
              </Stack.Item>
            </Stack.Item>
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="start">
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Floor"
                    // defaultSelectedKey={state.searchObj.floorId}
                    selectedKey={state.searchObj.floorId}
                    onRenderOption={onRenderOption}
                    onRenderTitle={onRenderTitle}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allFloorsDropdownList}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            floorId: v.key as string,
                            pacId: state.pacObj[v.key][0].key,
                          },
                          allPacDropdownList: state.pacObj[v.key],
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a PAC/PAHU"
                    // label="Role"
                    // defaultSelectedKey={state.searchObj.pacId}
                    selectedKey={state.searchObj.pacId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allPacDropdownList}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            pacId: v.key as string,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    showMonthPickerAsOverlay={true}
                    value={new Date(state.searchObj.date)}
                    showGoToToday={false}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        searchObj: { ...state.searchObj, date: date as Date },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                    styles={{ root: { width: 200 } }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* <Stack.Item>
              <DefaultButton
                text="Accept"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              &nbsp;&nbsp;
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item> */}
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="space-between" wrap>
            <Stack.Item className="ml-6">
              <span
                onClick={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[1]?.key ===
                      state.searchObj.floorId &&
                      state.allPacDropdownList[0]?.key === state.searchObj.pacId)
                    ? undefined
                    : () => onNextOrPrevFunc(true)
                }
                className={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[1]?.key ===
                      state.searchObj.floorId &&
                      state.allPacDropdownList[0]?.key === state.searchObj.pacId)
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <Icon
                  path={mdiChevronLeft}
                  size={0.9}
                  className="btnIcon"
                  style={{
                    marginBottom: -6,
                    marginRight: -8,
                    color: BRAND_SECONDARY,
                  }}
                />
                <DefaultButton
                  text="Previous PAHU"
                  className="borderless-btn"
                // disabled={
                // state.allFloorsDropdownList[1].key ===
                //   state.searchObj.floorId &&
                // state.allPacDropdownList[0].key === state.searchObj.pacId
                //   }
                // onClick={() => {
                //   onNextOrPrevFunc(true);
                // }}
                />
              </span>
              <span className="nxt-prv-btn-border"></span>
              <span
                onClick={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[
                      state.allFloorsDropdownList.length - 1
                    ]?.key === state.searchObj.floorId &&
                      state.allPacDropdownList[
                        state.allPacDropdownList.length - 1
                      ]?.key === state.searchObj.pacId)
                    ? undefined
                    : () => onNextOrPrevFunc(false)
                }
                className={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[
                      state.allFloorsDropdownList.length - 1
                    ]?.key === state.searchObj.floorId &&
                      state.allPacDropdownList[
                        state.allPacDropdownList.length - 1
                      ]?.key === state.searchObj.pacId)
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <DefaultButton
                  text="Next PAHU"
                  // disabled={
                  // state.allT state.allFloorsDropdownList[
                  //     state.allFloorsDropdownList.length - 1
                  //   ].key === state.searchObj.floorId &&
                  //   state.allPacDropdownList[
                  //     state.allPacDropdownList.length - 1
                  //   ].key === state.searchObj.pacIdate.serchObj.transformerId
                  // }
                  // onClick={() => {
                  //   onNextOrPrevFunc(false);
                  // }}
                  className="borderless-btn"
                />
                <Icon
                  path={mdiChevronRight}
                  size={0.9}
                  className="btnIcon"
                  style={{ marginBottom: -6, marginLeft: -8, color: BRAND_SECONDARY }}
                />
              </span>
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8 custom-secondary-btn"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
                className="custom-secondary-btn"
              />
            </Stack.Item>
          </Stack>
          {/* <Stack horizontal horizontalAlign="end" wrap>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item>
          </Stack> */}
          <br />
          {state.isPacLoaded && (
            <Stack>
              <div className="office-table bg-white">
                <table className="ms-Table bordered-table w-100">
                  <thead className="html-table-thead">
                    <tr style={{ height: 50 }}>
                      <th rowSpan={2}>
                        <Checkbox
                          //   indeterminate={state.isIndeterminate}
                          checked={state.isAllChecked}
                          onChange={(eve, checked) =>
                            onSelectAll(checked as boolean)
                          }
                        />
                      </th>
                      <th rowSpan={2}>Time in Hrs</th>
                      <th rowSpan={2}>System</th>
                      <th rowSpan={2}>
                        {!isMumbaiAndheri ? "Supply Temp ℃" : "RAT"}
                      </th>
                      <th rowSpan={2}>RH (%)</th>
                      <th rowSpan={2}>CRAC Room Temp ℃</th>
                      <th rowSpan={2}>Temp Set Point</th>
                      <th rowSpan={2}>RH Set Point</th>
                      <th rowSpan={2}>
                        Check for any abnormal sound/Alarm in PAHU
                      </th>
                      <th rowSpan={2}>Operator Signature</th>
                      <th rowSpan={2}>Status</th>
                      <th rowSpan={2}>Remarks</th>
                      <th rowSpan={2}>Read At</th>
                      <th rowSpan={2}>Actions</th>
                    </tr>
                    <tr></tr>
                  </thead>
                  <tbody>
                    {EVEN_SHIFT.map((ele, index) => {
                      let item = state.pacReading.find(
                        (e) => e.shiftTime === ele
                      );
                      return (
                        <tr key={index}>
                          <th>
                            <Checkbox
                              disabled={!item || item.status !== "submitted"}
                              checked={state.selectedItems.includes(
                                item?._id as string
                              )}
                              onChange={() =>
                                onIndividualSelect(item?._id as string)
                              }
                              className="ml-12"
                            />
                          </th>
                          <th> {ele} </th>
                          <td>
                            {item?.isOn !== undefined
                              ? item?.isOn === true
                                ? "On"
                                : "Off"
                              : ""}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.supplyTemp || "",
                                "supplyTemp",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.supplyTemp || ""}
                            {isInThreshold(
                              item?.supplyTemp || "",
                              "supplyTemp",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.supplyTemp || "",
                                      "supplyTemp",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.rh || "",
                                "rh",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.rh || ""}
                            {isInThreshold(
                              item?.rh || "",
                              "rh",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.rh || "",
                                      "rh",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.roomTemp || "",
                                "roomTemp",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.roomTemp || ""}
                            {isInThreshold(
                              item?.roomTemp || "",
                              "roomTemp",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.roomTemp || "",
                                      "roomTemp",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.tempSetPoint || "",
                                "tempSetPoint",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.tempSetPoint || ""}
                            {isInThreshold(
                              item?.tempSetPoint || "",
                              "tempSetPoint",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.tempSetPoint || "",
                                      "tempSetPoint",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.rhSetPoint || "",
                                "rhSetPoint",
                                state.threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.rhSetPoint || ""}
                            {isInThreshold(
                              item?.rhSetPoint || "",
                              "rhSetPoint",
                              state.threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.rhSetPoint || "",
                                      "rhSetPoint",
                                      state.threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td>{item?.anyAlarm || ""}</td>
                          <td>{item?.recordedBy || ""}</td>
                          <td>
                            {item && item.status ? UPS_STATUS[item.status] : ""}
                          </td>
                          <td>{item?.remarks || ""}</td>
                          <td>
                            {item?.date
                              ? moment(item.date).format(READ_AT_TIME_FORMAT)
                              : ""}
                          </td>
                          <td align="center" className="no-wrap">
                            {item && item.status === "submitted" && (
                              <span
                                onClick={(ele) =>
                                  handleCallOutOpenClose(true, ele, item)
                                }
                              >
                                <Icon
                                  path={mdiDotsVertical}
                                  size={0.9}
                                  className="pointer"
                                  color={BRAND_SECONDARY}
                                />
                              </span>
                              // <React.Fragment>
                              //   <TooltipHost
                              //     content="Update"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleDialogOpen(
                              //           true,
                              //           item?._id as string
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiPencil}
                              //         size={0.7}
                              //         className="pointer"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Accept"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleAcceptOrReject(
                              //           item?._id as string,
                              //           true
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiCheck}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="green"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Reject"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleRejectOpenDialog(
                              //           item?._id as string,
                              //           item?.remarks
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiClose}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="red"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              // </React.Fragment>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {/* <div className="next-prev-btn">
                <div>
                  <DefaultButton
                    text="Previous PAHU"
                    className="mr-8"
                    disabled={
                      state.allFloorsDropdownList[1].key ===
                        state.searchObj.floorId &&
                      state.allPacDropdownList[0].key === state.searchObj.pacId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(true);
                    }}
                  />
                  <DefaultButton
                    text="Next PAHU"
                    disabled={
                      state.allFloorsDropdownList[
                        state.allFloorsDropdownList.length - 1
                      ].key === state.searchObj.floorId &&
                      state.allPacDropdownList[
                        state.allPacDropdownList.length - 1
                      ].key === state.searchObj.pacId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(false);
                    }}
                  />
                </div>
              </div> */}
            </Stack>
          )}
        </React.Fragment>
      ) : (
        <NoDataTile
          title="No Datacenter Found"
          description="Datacenter either deleted or not created"
        />
      )}
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleDialogOpen(
                    true,
                    state.manageActionsCallout.data?._id as string
                  )
                }
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleAcceptOrReject(
                    state.manageActionsCallout.data?._id as string,
                    true
                  )
                }
                className="callout-options"
              >
                Accept
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleRejectOpenDialog(
                    state.manageActionsCallout.data?._id as string,
                    state.manageActionsCallout.data?.remarks
                  )
                }
                className="callout-options"
              >
                Reject
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.managePacDialog.isOpen && (
        <ManagePacDialog
          handleDialogClose={(data: IPACReading) => handleDialogClose(data)}
          data={state.managePacDialog.data}
          handleLoading={handleLoading}
          threshold={state.threshold}
        />
      )}
      {state.manageRejectDialog.isOpen && (
        <ManageAllRejectDialog
          handleRejectCloseDialog={(isSuccess: boolean, remarks?: string) =>
            handleRejectCloseDialog(isSuccess, remarks)
          }
          remarks={state.manageRejectDialog.remarks}
          subText="pac reading"
        />
      )}
    </React.Fragment>
  );
};

export default PacMain;
